// @ts-nocheck

import Reporter from '../../managers/reporter';
import { ReportActionTypes } from '../../types/actions/report';
import { type HandlerProps } from '../synchronousMiddleware';
export const handledActionTypes = [ReportActionTypes.SEND];

const reportMiddlewareHandler = ({ store: { getState }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    if (action.type === ReportActionTypes.SEND) {
      const { user } = getState();

      Reporter.sendReport(action.payload, user?.jwt?.token);
    }
  }
};

export default reportMiddlewareHandler;
